export function removeDuplicateNewLines(text: string | undefined): string {
  // if text is is defined, removes consecutive new lines and replaces them with a single new line
  if (text === undefined) {
    return "";
  }
  return text.replace(/\n{2,}/g, "\n");
}
